(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-mch-sns]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-mce-sns-track]');
      const thumb = section.querySelector('[data-mce-sns-thumb]');
      const videos = [...track.querySelectorAll('video')];
      const dialog = section.querySelector('[data-mce-sns-dialog]');
      const stage = section.querySelector('[data-mce-sns-stage]');
      const larges = [...stage.querySelectorAll('video')];
      const visible = new Set();
      const play = (video) => {
        const result = video.play();
        if (result) result.catch(() => {});
      };
      const syncPlayback = () => {
        videos.forEach((video) => {
          const active = visible.has(video) && !document.hidden && !dialog.open;
          video.autoplay = active;
          if (active && video.dataset.loaded) play(video);
          else video.pause();
        });
      };
      const load = (video) => {
        if (video.dataset.loaded) return;
        const source = video.querySelector('source');
        source.src = source.dataset.src;
        video.dataset.loaded = 'true';
        video.load();
        syncPlayback();
      };
      videos.forEach((video) => { video.autoplay = false; video.muted = true; });
      if ('IntersectionObserver' in window) {
        const loadingObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            load(entry.target);
            loadingObserver.unobserve(entry.target);
          });
        }, { rootMargin: '200px 0px', threshold: 0 });
        const playbackObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= .08) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          syncPlayback();
        }, { threshold: [0, .08] });
        videos.forEach((video) => { loadingObserver.observe(video); playbackObserver.observe(video); });
        section.mchCleanup = () => { loadingObserver.disconnect(); playbackObserver.disconnect(); };
      } else {
        videos.forEach((video) => { visible.add(video); load(video); });
      }
      // 拡大表示（2026-10-16 商品ページと同じ）: 横並び＋スナップで指に追従、前後も再生して黒画面を防ぐ、切替時は頭から、シークバー。
      const buttons = [...section.querySelectorAll('[data-mce-sns-open]')];
      const dots = section.querySelector('[data-mce-sns-dots]');
      const seek = section.querySelector('[data-mce-sns-seek]');
      let current = -1, seeking = false, seekRaf = 0;
      const loadLarge = (i) => {
        const v = larges[i];
        if (!v) return;
        if (!v.getAttribute('src')) { v.src = buttons[i].dataset.mceSnsOpen; v.muted = true; v.preload = 'auto'; }
        play(v);
      };
      const paint = () => {
        const v = larges[current];
        if (seek && v && v.duration && !seeking) {
          seek.value = String(Math.round(v.currentTime / v.duration * 1000));
          seek.style.setProperty('--p', `${v.currentTime / v.duration * 100}%`);
        }
      };
      const tick = () => { paint(); seekRaf = dialog.open ? requestAnimationFrame(tick) : 0; };
      larges.forEach((v) => v.addEventListener('timeupdate', paint));
      if (seek) {
        seek.addEventListener('pointerdown', () => { seeking = true; });
        seek.addEventListener('input', () => {
          seeking = true;
          const v = larges[current];
          if (v && v.duration) v.currentTime = seek.value / 1000 * v.duration;
          seek.style.setProperty('--p', `${seek.value / 10}%`);
        });
        ['change', 'pointerup', 'pointercancel', 'touchend'].forEach((t) => seek.addEventListener(t, () => { seeking = false; }));
      }
      const activate = (index) => {
        if (index === current) return;
        current = index;
        [current - 1, current, current + 1].forEach(loadLarge);
        try { larges[current].currentTime = 0; } catch (e) {}
        larges.forEach((v, i) => { if (Math.abs(i - current) > 1) v.pause(); });
        if (dots) [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      };
      stage.addEventListener('scroll', () => {
        if (!dialog.open || !stage.clientWidth) return;
        activate(Math.max(0, Math.min(larges.length - 1, Math.round(stage.scrollLeft / stage.clientWidth))));
      }, { passive: true });
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          dialog.showModal();
          document.documentElement.classList.add('mce-sns-modal-open');
          syncPlayback();
          current = -1;
          stage.scrollLeft = index * stage.clientWidth;
          activate(index);
          if (!seekRaf) seekRaf = requestAnimationFrame(tick);
        });
      });
      dialog.addEventListener('keydown', (event) => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (step) { event.preventDefault(); stage.scrollTo({ left: (current + step) * stage.clientWidth, behavior: 'smooth' }); }
      });
      section.querySelector('[data-mce-sns-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        larges.forEach((v) => { v.pause(); v.removeAttribute('src'); v.load(); });
        current = -1;
        document.documentElement.classList.remove('mce-sns-modal-open');
        // 閉じた後に開いたボタンへ戻るフォーカスの枠を出さない
        [0, 60, 200].forEach((ms) => setTimeout(() => { if (section.contains(document.activeElement)) document.activeElement.blur(); }, ms));
        syncPlayback();
      });
      const updateRail = () => {
        const max = track.scrollWidth - track.clientWidth;
        const ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        thumb.style.width = `${ratio * 100}%`;
        thumb.style.transform = `translateX(${max > 0 ? Math.max(0, track.scrollLeft) / max * (1 - ratio) / ratio * 100 : 0}%)`;
      };
      track.addEventListener('scroll', updateRail, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        const distance = track.firstElementChild.offsetWidth + Number.parseFloat(getComputedStyle(track).columnGap);
        const positions = { ArrowRight: track.scrollLeft + distance, ArrowLeft: track.scrollLeft - distance, Home: 0, End: track.scrollWidth };
        if (!(event.key in positions)) return;
        event.preventDefault();
        track.scrollTo({ left: positions[event.key], behavior: 'auto' });
      });
      const railObserver = 'ResizeObserver' in window ? new ResizeObserver(updateRail) : null;
      railObserver?.observe(track);
      const visibility = () => {
        syncPlayback();
        if (dialog.open) {
          const v = larges[current];
          if (v) { if (document.hidden) v.pause(); else play(v); }
        }
      };
      document.addEventListener('visibilitychange', visibility);
      const cleanObservers = section.mchCleanup;
      section.mchCleanup = () => {
        cleanObservers?.();
        railObserver?.disconnect();
        document.removeEventListener('visibilitychange', visibility);
        videos.forEach((video) => video.pause());
        if (dialog.open) dialog.close();
      };
      updateRail();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-mch-sns]').forEach((section) => section.mchCleanup?.()));
})();
